import HTTPService from "@/core/services/HTTPService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import { useToast } from "vue-toastification";
import UserService from "@/core/services/UserService";
import ApiService from "@/core/services/ApiService";
import { useUserSettingsStore } from "@/store/pinia/UserSettingsModule";
const toast = useToast();

export interface User {
  name: string;
  surname: string;
  email: string;
  password: string;
}

export interface UserAuthInfo {
  errors: object;
  user: User;
  isAuthenticated: boolean;
}

@Module
export default class AuthModule extends VuexModule implements UserAuthInfo {
  errors = [] as Array<any>;
  user = {} as User;
  isAuthenticated = true; // !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get currentUser(): User {
    return this.user;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */
  get isUserAuthenticated(): boolean {
    return this.isAuthenticated;
  }

  public test;
  /**
   * Get authentification errors
   * @returns array
   */
  get getErrors() {
    return this.errors;
  }

  @Mutation
  [Mutations.SET_ERROR](error: any) {
    this.errors.push(error);
  }

  @Mutation
  clearError() {
    this.errors = [];
  }

  @Mutation
  [Mutations.SET_AUTH](data: any) {
    /*
    this.isAuthenticated = true;
    this.user = user;
    this.errors = {};
    */
    // JwtService.saveToken(user.authorization.token);
    // ApiService.createRequestHandler();
    // AuthService.me();
  }

  @Mutation
  [Mutations.SET_USER](user) {
    this.user = user;
    // TODO write in localstorage
  }

  get [Mutations.GET_USER]() {
    return this.user;
  }

  @Mutation
  [Mutations.SET_PASSWORD](password) {
    this.user.password = password;
  }

  @Mutation
  [Mutations.PURGE_AUTH]() {
    useUserSettingsStore().reset();
    this.isAuthenticated = false;
    this.user = {} as User;
    this.errors = [];
    // JwtService.destroyToken();
  }

  @Action
  async [Actions.LOGIN](credentials: object) {
    try {
      this.context.commit("clearError");
      const { data } = await HTTPService.post("api/login", credentials);

      // Успех: сервер вернул token (формат { token, user } или { type: "success", token, user })
      if (data?.token) {
        UserService.saveToken(data.token);
        UserService.setUser(data.user || { id: 0 });
        ApiService.createRequestHandler();
        await useUserSettingsStore().load(UserService.getUser().id);
        return;
      }

      // Ошибка валидации или отказ (message или errors от Laravel)
      const message =
        data?.message ||
        (data?.errors && typeof data.errors === "string"
          ? data.errors
          : data?.errors?.email?.[0] || data?.errors?.password?.[0]) ||
        "Ошибка авторизации";
      this.context.commit(Mutations.SET_ERROR, message);
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.errors?.email?.[0] ||
        (error?.response?.status === 422 && "Неверный email или пароль") ||
        "Ошибка соединения с сервером";
      this.context.commit(Mutations.SET_ERROR, message);
    }
  }

  @Action
  [Actions.LOGOUT]() {
    this.context.commit(Mutations.PURGE_AUTH);
  }
}
